import React from 'react';
import PeriodSelection from '../../ui/PeriodSelection/PeriodSelection';
import Card from '../../../../components/Card/Card';
import { ReactComponent as PeriodFilterIcon } from '../../../../../../resource/PeriodFilterIcon.svg';

const PeriodSelectionCard = () => {
  return (
    <Card
      heading="Период и выбор"
      icon={<PeriodFilterIcon />}
    >
      <PeriodSelection />
    </Card>
  );
};

export default PeriodSelectionCard;
